// extracted by mini-css-extract-plugin
export default {"projects_header":"ProjectsHeader_projects_header__QjlrH","projects_header_title":"ProjectsHeader_projects_header_title__MGpsS"};